export interface TipoSociedad {
    id: number;
    nombre: string;
  }
  
  export const TIPOS_SOCIEDAD: TipoSociedad[] = [
    { id: 1, nombre: 'ANONIMA' },
    { id: 2, nombre: 'LIMITADA' },
    { id: 3, nombre: 'MIXTA' },
    { id: 4, nombre: 'SAS' },
    { id: 5, nombre: 'EXTRANJERA' },
    { id: 6, nombre: 'PUBLICA' },
    { id: 7, nombre: 'COOPERATIVA' },
    { id: 8, nombre: 'UNIPERSONAL' }
  ];